// @ts-nocheck
import React from 'react';
import { ApplyPluginsType } from '/home/johan/jingqb/jingui/node_modules/.pnpm/@umijs+runtime@3.5.36_react@16.14.0/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';

export function getRoutes() {
  const routes = [
  {
    "path": "/~demos/:uuid",
    "layout": false,
    "wrappers": [require('../dumi/layout').default, require('/home/johan/jingqb/jingui/node_modules/dumi-theme-mobile/es/layouts/demo.js').default],
    "component": ((props) => {
        const React = require('react');
        const { default: getDemoRenderArgs } = require('/home/johan/jingqb/jingui/node_modules/.pnpm/@umijs+preset-dumi@1.1.50_33ra76l5kwdattnfxf73xw7yo4/node_modules/@umijs/preset-dumi/lib/plugins/features/demo/getDemoRenderArgs');
        const { default: Previewer } = require('dumi-theme-mobile/es/builtins/Previewer.js');
        const { usePrefersColor, context } = require('dumi/theme');

        
      const { demos } = React.useContext(context);
      const [renderArgs, setRenderArgs] = React.useState([]);

      // update render args when props changed
      React.useLayoutEffect(() => {
        setRenderArgs(getDemoRenderArgs(props, demos));
      }, [props.match.params.uuid, props.location.query.wrapper, props.location.query.capture]);

      // for listen prefers-color-schema media change in demo single route
      usePrefersColor();

      switch (renderArgs.length) {
        case 1:
          // render demo directly
          return renderArgs[0];

        case 2:
          // render demo with previewer
          return React.createElement(
            Previewer,
            renderArgs[0],
            renderArgs[1],
          );

        default:
          return `Demo ${props.match.params.uuid} not found :(`;
      }
    
        })
  },
  {
    "path": "/_demos/:uuid",
    "redirect": "/~demos/:uuid"
  },
  {
    "__dumiRoot": true,
    "layout": false,
    "path": "/",
    "wrappers": [require('../dumi/layout').default, require('/home/johan/jingqb/jingui/node_modules/dumi-theme-mobile/es/layouts/index.js').default],
    "routes": [
      {
        "path": "/components",
        "component": require('/home/johan/jingqb/jingui/src/components/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/index.md",
          "updatedTime": 1675157274000,
          "toc": false,
          "nav": {
            "title": "组件",
            "path": "/components"
          },
          "group": {
            "title": "组件总览",
            "path": "/components",
            "order": 1
          },
          "slugs": [
            {
              "depth": 1,
              "value": "组件总览",
              "heading": "组件总览"
            },
            {
              "depth": 2,
              "value": "写在前面",
              "heading": "写在前面"
            },
            {
              "depth": 2,
              "value": "基础组件",
              "heading": "基础组件"
            },
            {
              "depth": 2,
              "value": "布局组件",
              "heading": "布局组件"
            },
            {
              "depth": 2,
              "value": "展示组件",
              "heading": "展示组件"
            },
            {
              "depth": 2,
              "value": "反馈组件",
              "heading": "反馈组件"
            },
            {
              "depth": 2,
              "value": "导航组件",
              "heading": "导航组件"
            },
            {
              "depth": 2,
              "value": "业务组件",
              "heading": "业务组件"
            },
            {
              "depth": 2,
              "value": "其他",
              "heading": "其他"
            }
          ],
          "title": "组件总览"
        },
        "title": "组件总览 - Jing-ui"
      },
      {
        "path": "/components/work/area",
        "component": require('/home/johan/jingqb/jingui/src/components/Area/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/Area/index.md",
          "updatedTime": 1639106845000,
          "componentName": "Area",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "业务组件",
            "path": "/components/work",
            "order": 7
          },
          "slugs": [
            {
              "depth": 1,
              "value": "Area 地址",
              "heading": "area-地址"
            },
            {
              "depth": 2,
              "value": "代码演示",
              "heading": "代码演示"
            }
          ],
          "title": "Area 地址"
        },
        "title": "Area 地址 - Jing-ui"
      },
      {
        "path": "/components/feedback/better-scroll",
        "component": require('/home/johan/jingqb/jingui/src/components/BetterScroll/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/BetterScroll/index.md",
          "updatedTime": 1637057555000,
          "componentName": "BetterScroll",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "反馈组件",
            "path": "/components/feedback",
            "order": 5
          },
          "slugs": [
            {
              "depth": 1,
              "value": "Scroll 滚动条",
              "heading": "scroll-滚动条"
            },
            {
              "depth": 3,
              "value": "API",
              "heading": "api"
            }
          ],
          "title": "Scroll 滚动条",
          "hasPreviewer": true
        },
        "title": "Scroll 滚动条 - Jing-ui"
      },
      {
        "path": "/components/base/button",
        "component": require('/home/johan/jingqb/jingui/src/components/Button/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/Button/index.md",
          "updatedTime": 1666246701000,
          "componentName": "Button",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "基础组件",
            "path": "/components/base",
            "order": 2
          },
          "slugs": [
            {
              "depth": 1,
              "value": "Button 按钮",
              "heading": "button-按钮"
            },
            {
              "depth": 2,
              "value": "代码演示",
              "heading": "代码演示"
            },
            {
              "depth": 2,
              "value": "API",
              "heading": "api"
            },
            {
              "depth": 3,
              "value": "ButtonGroup API",
              "heading": "buttongroup-api"
            }
          ],
          "title": "Button 按钮",
          "hasPreviewer": true
        },
        "title": "Button 按钮 - Jing-ui"
      },
      {
        "path": "/components/base/cell",
        "component": require('/home/johan/jingqb/jingui/src/components/Cell/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/Cell/index.md",
          "updatedTime": 1677228633000,
          "componentName": "Cell",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "基础组件",
            "path": "/components/base",
            "order": 2
          },
          "slugs": [
            {
              "depth": 1,
              "value": "Cell 列表项",
              "heading": "cell-列表项"
            },
            {
              "depth": 3,
              "value": "代码演示",
              "heading": "代码演示"
            },
            {
              "depth": 3,
              "value": "Cell API",
              "heading": "cell-api"
            },
            {
              "depth": 3,
              "value": "CellGroup API",
              "heading": "cellgroup-api"
            }
          ],
          "title": "Cell 列表项",
          "hasPreviewer": true
        },
        "title": "Cell 列表项 - Jing-ui"
      },
      {
        "path": "/components/config/config-provider",
        "component": require('/home/johan/jingqb/jingui/src/components/ConfigProvider/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/ConfigProvider/index.md",
          "updatedTime": 1675411501000,
          "componentName": "ConfigProvider",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "其他",
            "path": "/components/config",
            "order": 9
          },
          "slugs": [
            {
              "depth": 1,
              "value": "ConfigProvider 全局配置",
              "heading": "configprovider-全局配置"
            },
            {
              "depth": 3,
              "value": "代码演示",
              "heading": "代码演示"
            },
            {
              "depth": 3,
              "value": "API",
              "heading": "api"
            }
          ],
          "title": "ConfigProvider 全局配置",
          "hasPreviewer": true
        },
        "title": "ConfigProvider 全局配置 - Jing-ui"
      },
      {
        "path": "/components/work/connect-footer",
        "component": require('/home/johan/jingqb/jingui/src/components/ConnectFooter/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/ConnectFooter/index.md",
          "updatedTime": 1676357224000,
          "componentName": "ConnectFooter",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "业务组件",
            "path": "/components/work",
            "order": 7
          },
          "slugs": [
            {
              "depth": 1,
              "value": "ConnectFooter 页面尾部提示",
              "heading": "connectfooter-页面尾部提示"
            },
            {
              "depth": 3,
              "value": "代码演示",
              "heading": "代码演示"
            },
            {
              "depth": 3,
              "value": "API",
              "heading": "api"
            }
          ],
          "title": "ConnectFooter 页面尾部提示",
          "hasPreviewer": true
        },
        "title": "ConnectFooter 页面尾部提示 - Jing-ui"
      },
      {
        "path": "/components/base/divider",
        "component": require('/home/johan/jingqb/jingui/src/components/Divider/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/Divider/index.md",
          "updatedTime": 1636106179000,
          "componentName": "Divider",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "基础组件",
            "path": "/components/base",
            "order": 2
          },
          "slugs": [
            {
              "depth": 1,
              "value": "Divider 分隔线",
              "heading": "divider-分隔线"
            },
            {
              "depth": 3,
              "value": "代码演示",
              "heading": "代码演示"
            },
            {
              "depth": 3,
              "value": "API",
              "heading": "api"
            }
          ],
          "title": "Divider 分隔线",
          "hasPreviewer": true
        },
        "title": "Divider 分隔线 - Jing-ui"
      },
      {
        "path": "/components/work/floating-ad",
        "component": require('/home/johan/jingqb/jingui/src/components/FloatingAd/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/FloatingAd/index.md",
          "updatedTime": 1674985203000,
          "componentName": "FloatingAd",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "业务组件",
            "path": "/components/work",
            "order": 7
          },
          "slugs": [
            {
              "depth": 1,
              "value": "FloatingAd 悬浮广告",
              "heading": "floatingad-悬浮广告"
            },
            {
              "depth": 3,
              "value": "代码演示",
              "heading": "代码演示"
            },
            {
              "depth": 3,
              "value": "API",
              "heading": "api"
            }
          ],
          "title": "FloatingAd 悬浮广告",
          "hasPreviewer": true
        },
        "title": "FloatingAd 悬浮广告 - Jing-ui"
      },
      {
        "path": "/components/base/icon",
        "component": require('/home/johan/jingqb/jingui/src/components/Icon/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/Icon/index.md",
          "updatedTime": 1677036443000,
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "基础组件",
            "path": "/components/base",
            "order": 2
          },
          "slugs": [
            {
              "depth": 1,
              "value": "Icon 图标",
              "heading": "icon-图标"
            },
            {
              "depth": 3,
              "value": "代码演示",
              "heading": "代码演示"
            },
            {
              "depth": 3,
              "value": "API",
              "heading": "api"
            }
          ],
          "title": "Icon 图标",
          "hasPreviewer": true
        },
        "title": "Icon 图标 - Jing-ui"
      },
      {
        "path": "/components/base/image",
        "component": require('/home/johan/jingqb/jingui/src/components/Image/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/Image/index.md",
          "updatedTime": 1640339183000,
          "componentName": "Image",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "基础组件",
            "path": "/components/base",
            "order": 2
          },
          "slugs": [
            {
              "depth": 1,
              "value": "Image 图片",
              "heading": "image-图片"
            },
            {
              "depth": 3,
              "value": "代码演示",
              "heading": "代码演示"
            },
            {
              "depth": 3,
              "value": "API",
              "heading": "api"
            }
          ],
          "title": "Image 图片",
          "hasPreviewer": true
        },
        "title": "Image 图片 - Jing-ui"
      },
      {
        "path": "/components/navigation/index-bar",
        "component": require('/home/johan/jingqb/jingui/src/components/IndexBar/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/IndexBar/index.md",
          "updatedTime": 1640339183000,
          "componentName": "IndexBar",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "导航组件",
            "path": "/components/navigation",
            "order": 6
          },
          "slugs": [
            {
              "depth": 1,
              "value": "IndexBar 索引栏",
              "heading": "indexbar-索引栏"
            },
            {
              "depth": 3,
              "value": "代码演示",
              "heading": "代码演示"
            },
            {
              "depth": 3,
              "value": "API",
              "heading": "api"
            }
          ],
          "title": "IndexBar 索引栏",
          "hasPreviewer": true
        },
        "title": "IndexBar 索引栏 - Jing-ui"
      },
      {
        "path": "/components/data/input",
        "component": require('/home/johan/jingqb/jingui/src/components/Input/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/Input/index.md",
          "updatedTime": 1676964835000,
          "componentName": "Input",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "展示组件",
            "path": "/components/data",
            "order": 4
          },
          "slugs": [
            {
              "depth": 1,
              "value": "Input 输入",
              "heading": "input-输入"
            },
            {
              "depth": 3,
              "value": "代码演示",
              "heading": "代码演示"
            },
            {
              "depth": 3,
              "value": "Input API",
              "heading": "input-api"
            },
            {
              "depth": 3,
              "value": "Input.Textarea API",
              "heading": "inputtextarea-api"
            },
            {
              "depth": 3,
              "value": "Input.Keyboard API",
              "heading": "inputkeyboard-api"
            }
          ],
          "title": "Input 输入",
          "hasPreviewer": true
        },
        "title": "Input 输入 - Jing-ui"
      },
      {
        "path": "/components/data/key-board",
        "component": require('/home/johan/jingqb/jingui/src/components/KeyBoard/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/KeyBoard/index.md",
          "updatedTime": 1655892250000,
          "componentName": "KeyBoard",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "展示组件",
            "path": "/components/data",
            "order": 4
          },
          "slugs": [
            {
              "depth": 1,
              "value": "Keyboard 自定义键盘",
              "heading": "keyboard-自定义键盘"
            },
            {
              "depth": 2,
              "value": "代码演示",
              "heading": "代码演示"
            },
            {
              "depth": 3,
              "value": "基本用法",
              "heading": "基本用法"
            },
            {
              "depth": 2,
              "value": "API",
              "heading": "api"
            },
            {
              "depth": 2,
              "value": "KeyAPI",
              "heading": "keyapi"
            }
          ],
          "title": "Keyboard 自定义键盘",
          "hasPreviewer": true
        },
        "title": "Keyboard 自定义键盘 - Jing-ui"
      },
      {
        "path": "/components/layout",
        "component": require('/home/johan/jingqb/jingui/src/components/Layout/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/Layout/index.md",
          "updatedTime": 1655975402000,
          "componentName": "Layout",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "布局组件",
            "path": "/components/layout",
            "order": 3
          },
          "slugs": [
            {
              "depth": 1,
              "value": "Layout 栅格布局",
              "heading": "layout-栅格布局"
            },
            {
              "depth": 2,
              "value": "代码演示",
              "heading": "代码演示"
            },
            {
              "depth": 3,
              "value": "基础用法",
              "heading": "基础用法"
            },
            {
              "depth": 2,
              "value": "Row API",
              "heading": "row-api"
            },
            {
              "depth": 2,
              "value": "Col API",
              "heading": "col-api"
            }
          ],
          "title": "Layout 栅格布局",
          "hasPreviewer": true
        },
        "title": "Layout 栅格布局 - Jing-ui"
      },
      {
        "path": "/components/feedback/loading",
        "component": require('/home/johan/jingqb/jingui/src/components/Loading/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/Loading/index.md",
          "updatedTime": 1639727268000,
          "componentName": "Loading",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "反馈组件",
            "path": "/components/feedback",
            "order": 5
          },
          "slugs": [
            {
              "depth": 1,
              "value": "Loading 加载",
              "heading": "loading-加载"
            },
            {
              "depth": 2,
              "value": "API",
              "heading": "api"
            }
          ],
          "title": "Loading 加载",
          "hasPreviewer": true
        },
        "title": "Loading 加载 - Jing-ui"
      },
      {
        "path": "/components/feedback/modal",
        "component": require('/home/johan/jingqb/jingui/src/components/Modal/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/Modal/index.md",
          "updatedTime": 1666246701000,
          "componentName": "Modal",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "反馈组件",
            "path": "/components/feedback",
            "order": 5
          },
          "slugs": [
            {
              "depth": 1,
              "value": "Modal 模态框",
              "heading": "modal-模态框"
            },
            {
              "depth": 2,
              "value": "方法",
              "heading": "方法"
            },
            {
              "depth": 2,
              "value": "API Props",
              "heading": "api-props"
            }
          ],
          "title": "Modal 模态框",
          "hasPreviewer": true
        },
        "title": "Modal 模态框 - Jing-ui"
      },
      {
        "path": "/components/data/notice-bar",
        "component": require('/home/johan/jingqb/jingui/src/components/NoticeBar/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/NoticeBar/index.md",
          "updatedTime": 1639384549000,
          "componentName": "NoticeBar",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "展示组件",
            "path": "/components/data",
            "order": 5
          },
          "slugs": [
            {
              "depth": 1,
              "value": "NoticeBar 通知栏",
              "heading": "noticebar-通知栏"
            },
            {
              "depth": 3,
              "value": "代码演示",
              "heading": "代码演示"
            },
            {
              "depth": 3,
              "value": "API",
              "heading": "api"
            }
          ],
          "title": "NoticeBar 通知栏",
          "hasPreviewer": true
        },
        "title": "NoticeBar 通知栏 - Jing-ui"
      },
      {
        "path": "/components/work/orientation",
        "component": require('/home/johan/jingqb/jingui/src/components/Orientation/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/Orientation/index.md",
          "updatedTime": 1676439572000,
          "componentName": "Orientation",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "业务组件",
            "path": "/components/work",
            "order": 7
          },
          "slugs": [
            {
              "depth": 1,
              "value": "Orientation 方向",
              "heading": "orientation-方向"
            },
            {
              "depth": 3,
              "value": "代码演示",
              "heading": "代码演示"
            }
          ],
          "title": "Orientation 方向",
          "hasPreviewer": true
        },
        "title": "Orientation 方向 - Jing-ui"
      },
      {
        "path": "/components/base/overlay",
        "component": require('/home/johan/jingqb/jingui/src/components/Overlay/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/Overlay/index.md",
          "updatedTime": 1639734653000,
          "componentName": "Overlay",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "基础组件",
            "path": "/components/base",
            "order": 2
          },
          "slugs": [
            {
              "depth": 1,
              "value": "Overlay 遮罩层",
              "heading": "overlay-遮罩层"
            },
            {
              "depth": 3,
              "value": "代码演示",
              "heading": "代码演示"
            },
            {
              "depth": 3,
              "value": "API",
              "heading": "api"
            }
          ],
          "title": "Overlay 遮罩层",
          "hasPreviewer": true
        },
        "title": "Overlay 遮罩层 - Jing-ui"
      },
      {
        "path": "/components/feedback/page-loading",
        "component": require('/home/johan/jingqb/jingui/src/components/PageLoading/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/PageLoading/index.md",
          "updatedTime": 1637748596000,
          "componentName": "PageLoading",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "反馈组件",
            "path": "/components/feedback",
            "order": 5
          },
          "slugs": [
            {
              "depth": 1,
              "value": "PageLoading 页面加载",
              "heading": "pageloading-页面加载"
            },
            {
              "depth": 3,
              "value": "",
              "heading": ""
            },
            {
              "depth": 2,
              "value": "API",
              "heading": "api"
            }
          ],
          "title": "PageLoading 页面加载",
          "hasPreviewer": true
        },
        "title": "PageLoading 页面加载 - Jing-ui"
      },
      {
        "path": "/components/data/panel",
        "component": require('/home/johan/jingqb/jingui/src/components/Panel/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/Panel/index.md",
          "updatedTime": 1640340283000,
          "componentName": "Panel",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "展示组件",
            "path": "/components/data",
            "order": 4
          },
          "slugs": [
            {
              "depth": 1,
              "value": "Panel 面板",
              "heading": "panel-面板"
            },
            {
              "depth": 3,
              "value": "代码演示",
              "heading": "代码演示"
            },
            {
              "depth": 3,
              "value": "API",
              "heading": "api"
            }
          ],
          "title": "Panel 面板",
          "hasPreviewer": true
        },
        "title": "Panel 面板 - Jing-ui"
      },
      {
        "path": "/components/data/password-input",
        "component": require('/home/johan/jingqb/jingui/src/components/PasswordInput/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/PasswordInput/index.md",
          "updatedTime": 1676283082000,
          "componentName": "PasswordInput",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "展示组件",
            "path": "/components/data",
            "order": 4
          },
          "slugs": [
            {
              "depth": 1,
              "value": "PasswordInput 密码输入框",
              "heading": "passwordinput-密码输入框"
            },
            {
              "depth": 2,
              "value": "引入",
              "heading": "引入"
            },
            {
              "depth": 2,
              "value": "代码演示",
              "heading": "代码演示"
            },
            {
              "depth": 3,
              "value": "API",
              "heading": "api"
            }
          ],
          "title": "PasswordInput 密码输入框",
          "hasPreviewer": true
        },
        "title": "PasswordInput 密码输入框 - Jing-ui"
      },
      {
        "path": "/components/data/picker",
        "component": require('/home/johan/jingqb/jingui/src/components/Picker/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/Picker/index.md",
          "updatedTime": 1655715322000,
          "componentName": "Picker",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "展示组件",
            "path": "/components/data",
            "order": 4
          },
          "slugs": [
            {
              "depth": 1,
              "value": "Picker 选择器",
              "heading": "picker-选择器"
            },
            {
              "depth": 3,
              "value": "代码演示",
              "heading": "代码演示"
            },
            {
              "depth": 3,
              "value": "API",
              "heading": "api"
            }
          ],
          "title": "Picker 选择器",
          "hasPreviewer": true
        },
        "title": "Picker 选择器 - Jing-ui"
      },
      {
        "path": "/components/feedback/popup",
        "component": require('/home/johan/jingqb/jingui/src/components/Popup/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/Popup/index.md",
          "updatedTime": 1655196100000,
          "componentName": "Popup",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "反馈组件",
            "path": "/components/feedback",
            "order": 5
          },
          "slugs": [
            {
              "depth": 1,
              "value": "Popup 弹出层",
              "heading": "popup-弹出层"
            },
            {
              "depth": 3,
              "value": "代码演示",
              "heading": "代码演示"
            },
            {
              "depth": 3,
              "value": "API",
              "heading": "api"
            }
          ],
          "title": "Popup 弹出层",
          "hasPreviewer": true
        },
        "title": "Popup 弹出层 - Jing-ui"
      },
      {
        "path": "/components/work/popup-middle",
        "component": require('/home/johan/jingqb/jingui/src/components/PopupMiddle/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/PopupMiddle/index.md",
          "updatedTime": 1676541676000,
          "componentName": "PopupMiddle",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "业务组件",
            "path": "/components/work",
            "order": 7
          },
          "slugs": [
            {
              "depth": 1,
              "value": "PopupMiddle 弹中容",
              "heading": "popupmiddle-弹中容"
            },
            {
              "depth": 3,
              "value": "代码演示",
              "heading": "代码演示"
            }
          ],
          "title": "PopupMiddle 弹中容",
          "hasPreviewer": true
        },
        "title": "PopupMiddle 弹中容 - Jing-ui"
      },
      {
        "path": "/components/data/radio",
        "component": require('/home/johan/jingqb/jingui/src/components/Radio/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/Radio/index.md",
          "updatedTime": 1638958378000,
          "componentName": "Radio",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "展示组件",
            "path": "/components/data",
            "order": 4
          },
          "slugs": [
            {
              "depth": 1,
              "value": "Radio 单选框",
              "heading": "radio-单选框"
            }
          ],
          "title": "Radio 单选框"
        },
        "title": "Radio 单选框 - Jing-ui"
      },
      {
        "path": "/components/data/result",
        "component": require('/home/johan/jingqb/jingui/src/components/Result/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/Result/index.md",
          "updatedTime": 1676363595000,
          "componentName": "Result",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "反馈组件",
            "path": "/components/data",
            "order": 3
          },
          "slugs": [
            {
              "depth": 1,
              "value": "Result 结果",
              "heading": "result-结果"
            },
            {
              "depth": 2,
              "value": "代码演示",
              "heading": "代码演示"
            },
            {
              "depth": 3,
              "value": "API",
              "heading": "api"
            }
          ],
          "title": "Result 结果",
          "hasPreviewer": true
        },
        "title": "Result 结果 - Jing-ui"
      },
      {
        "path": "/components/work/sort-bar",
        "component": require('/home/johan/jingqb/jingui/src/components/SortBar/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/SortBar/index.md",
          "updatedTime": 1640221288000,
          "componentName": "SortBar",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "业务组件",
            "path": "/components/work",
            "order": 7
          },
          "slugs": [
            {
              "depth": 1,
              "value": "SortBar 排序栏",
              "heading": "sortbar-排序栏"
            },
            {
              "depth": 3,
              "value": "代码演示",
              "heading": "代码演示"
            },
            {
              "depth": 3,
              "value": "SortBar API",
              "heading": "sortbar-api"
            },
            {
              "depth": 3,
              "value": "SortBarItem API",
              "heading": "sortbaritem-api"
            }
          ],
          "title": "SortBar 排序栏",
          "hasPreviewer": true
        },
        "title": "SortBar 排序栏 - Jing-ui"
      },
      {
        "path": "/components/layout/space",
        "component": require('/home/johan/jingqb/jingui/src/components/Space/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/Space/index.md",
          "updatedTime": 1638860726000,
          "componentName": "Space",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "布局组件",
            "path": "/components/layout",
            "order": 3
          },
          "slugs": [
            {
              "depth": 1,
              "value": "Space 空行分隔",
              "heading": "space-空行分隔"
            },
            {
              "depth": 2,
              "value": "代码演示",
              "heading": "代码演示"
            },
            {
              "depth": 2,
              "value": "API",
              "heading": "api"
            }
          ],
          "title": "Space 空行分隔",
          "hasPreviewer": true
        },
        "title": "Space 空行分隔 - Jing-ui"
      },
      {
        "path": "/components/layout/sticky",
        "component": require('/home/johan/jingqb/jingui/src/components/Sticky/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/Sticky/index.md",
          "updatedTime": 1640339183000,
          "componentName": "Sticky",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "布局组件",
            "path": "/components/layout",
            "order": 3
          },
          "slugs": [
            {
              "depth": 1,
              "value": "Sticky 粘性布局",
              "heading": "sticky-粘性布局"
            },
            {
              "depth": 2,
              "value": "代码演示",
              "heading": "代码演示"
            },
            {
              "depth": 2,
              "value": "API",
              "heading": "api"
            }
          ],
          "title": "Sticky 粘性布局",
          "hasPreviewer": true
        },
        "title": "Sticky 粘性布局 - Jing-ui"
      },
      {
        "path": "/components/base/style",
        "component": require('/home/johan/jingqb/jingui/src/components/Style/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/Style/index.md",
          "updatedTime": 1655859135000,
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "基础组件",
            "path": "/components/base",
            "order": 2
          },
          "slugs": [
            {
              "depth": 1,
              "value": "Style 内置样式",
              "heading": "style-内置样式"
            },
            {
              "depth": 3,
              "value": "介绍",
              "heading": "介绍"
            },
            {
              "depth": 3,
              "value": "文字省略",
              "heading": "文字省略"
            },
            {
              "depth": 3,
              "value": "1px 边框",
              "heading": "1px-边框"
            },
            {
              "depth": 3,
              "value": "安全区",
              "heading": "安全区"
            },
            {
              "depth": 3,
              "value": "动画",
              "heading": "动画"
            }
          ],
          "title": "Style 内置样式",
          "hasPreviewer": true
        },
        "title": "Style 内置样式 - Jing-ui"
      },
      {
        "path": "/components/work/swiper",
        "component": require('/home/johan/jingqb/jingui/src/components/Swiper/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/Swiper/index.md",
          "updatedTime": 1682496465000,
          "componentName": "Swiper",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "业务组件",
            "path": "/components/work",
            "order": 7
          },
          "slugs": [
            {
              "depth": 1,
              "value": "Swiper 轮播",
              "heading": "swiper-轮播"
            },
            {
              "depth": 2,
              "value": "代码演示",
              "heading": "代码演示"
            }
          ],
          "title": "Swiper 轮播",
          "hasPreviewer": true
        },
        "title": "Swiper 轮播 - Jing-ui"
      },
      {
        "path": "/components/data/switch",
        "component": require('/home/johan/jingqb/jingui/src/components/Switch/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/Switch/index.md",
          "updatedTime": 1676283082000,
          "componentName": "Switch",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "展示组件",
            "path": "/components/data",
            "order": 4
          },
          "slugs": [
            {
              "depth": 1,
              "value": "Switch 开关",
              "heading": "switch-开关"
            },
            {
              "depth": 2,
              "value": "代码演示",
              "heading": "代码演示"
            },
            {
              "depth": 2,
              "value": "API",
              "heading": "api"
            }
          ],
          "title": "Switch 开关",
          "hasPreviewer": true
        },
        "title": "Switch 开关 - Jing-ui"
      },
      {
        "path": "/components/navigation/tab-bar",
        "component": require('/home/johan/jingqb/jingui/src/components/TabBar/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/TabBar/index.md",
          "updatedTime": 1676517529000,
          "componentName": "TabBar",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "导航组件",
            "path": "/components/navigation",
            "order": 6
          },
          "slugs": [
            {
              "depth": 1,
              "value": "TabBar 标签栏",
              "heading": "tabbar-标签栏"
            },
            {
              "depth": 3,
              "value": "代码演示",
              "heading": "代码演示"
            },
            {
              "depth": 3,
              "value": "TabBar API",
              "heading": "tabbar-api"
            },
            {
              "depth": 3,
              "value": "TabBar.Item API",
              "heading": "tabbaritem-api"
            }
          ],
          "title": "TabBar 标签栏",
          "hasPreviewer": true
        },
        "title": "TabBar 标签栏 - Jing-ui"
      },
      {
        "path": "/components/navigation/tabs",
        "component": require('/home/johan/jingqb/jingui/src/components/Tabs/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/Tabs/index.md",
          "updatedTime": 1682486573000,
          "componentName": "Tabs",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "导航组件",
            "path": "/components/navigation",
            "order": 6
          },
          "slugs": [
            {
              "depth": 1,
              "value": "Tabs 标签页",
              "heading": "tabs-标签页"
            },
            {
              "depth": 2,
              "value": "代码演示",
              "heading": "代码演示"
            },
            {
              "depth": 3,
              "value": "Tabs API",
              "heading": "tabs-api"
            },
            {
              "depth": 3,
              "value": "Tabs API",
              "heading": "tabs-api-1"
            }
          ],
          "title": "Tabs 标签页",
          "hasPreviewer": true
        },
        "title": "Tabs 标签页 - Jing-ui"
      },
      {
        "path": "/components/data/tag",
        "component": require('/home/johan/jingqb/jingui/src/components/Tag/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/Tag/index.md",
          "updatedTime": 1682303671000,
          "componentName": "Tag",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "展示组件",
            "path": "/components/data",
            "order": 4
          },
          "slugs": [
            {
              "depth": 1,
              "value": "Tag 标签",
              "heading": "tag-标签"
            },
            {
              "depth": 3,
              "value": "代码演示",
              "heading": "代码演示"
            },
            {
              "depth": 3,
              "value": "API",
              "heading": "api"
            }
          ],
          "title": "Tag 标签",
          "hasPreviewer": true
        },
        "title": "Tag 标签 - Jing-ui"
      },
      {
        "path": "/components/work/timeline",
        "component": require('/home/johan/jingqb/jingui/src/components/Timeline/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/Timeline/index.md",
          "updatedTime": 1639106845000,
          "componentName": "Timeline",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "业务组件",
            "path": "/components/work",
            "order": 7
          },
          "slugs": [
            {
              "depth": 1,
              "value": "Timeline 时间线",
              "heading": "timeline-时间线"
            },
            {
              "depth": 2,
              "value": "代码演示",
              "heading": "代码演示"
            },
            {
              "depth": 2,
              "value": "API",
              "heading": "api"
            },
            {
              "depth": 3,
              "value": "Timeline props",
              "heading": "timeline-props"
            },
            {
              "depth": 3,
              "value": "TimelineItem Props",
              "heading": "timelineitem-props"
            }
          ],
          "title": "Timeline 时间线",
          "hasPreviewer": true
        },
        "title": "Timeline 时间线 - Jing-ui"
      },
      {
        "path": "/components/feedback/toast",
        "component": require('/home/johan/jingqb/jingui/src/components/Toast/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/Toast/index.md",
          "updatedTime": 1675319946000,
          "componentName": "Toast",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "反馈组件",
            "path": "/components/feedback",
            "order": 5
          },
          "slugs": [
            {
              "depth": 1,
              "value": "Toast 轻提示",
              "heading": "toast-轻提示"
            },
            {
              "depth": 3,
              "value": "代码演示",
              "heading": "代码演示"
            },
            {
              "depth": 3,
              "value": "方法",
              "heading": "方法"
            },
            {
              "depth": 3,
              "value": "属性",
              "heading": "属性"
            }
          ],
          "title": "Toast 轻提示",
          "hasPreviewer": true
        },
        "title": "Toast 轻提示 - Jing-ui"
      },
      {
        "path": "/components/data/typography",
        "component": require('/home/johan/jingqb/jingui/src/components/Typography/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "src/components/Typography/index.md",
          "updatedTime": 1640339183000,
          "componentName": "Typography",
          "toc": false,
          "nav": {
            "path": "/components",
            "title": "组件"
          },
          "group": {
            "title": "展示组件",
            "path": "/components/data",
            "order": 5
          },
          "slugs": [
            {
              "depth": 1,
              "value": "Typography 富文本",
              "heading": "typography-富文本"
            },
            {
              "depth": 3,
              "value": "代码演示",
              "heading": "代码演示"
            },
            {
              "depth": 3,
              "value": "API",
              "heading": "api"
            }
          ],
          "title": "Typography 富文本",
          "hasPreviewer": true
        },
        "title": "Typography 富文本 - Jing-ui"
      },
      {
        "path": "/",
        "component": require('/home/johan/jingqb/jingui/docs/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "docs/index.md",
          "updatedTime": 1658107099000,
          "title": "Jing-ui - 一套移动端组件库",
          "order": 10,
          "hero": {
            "title": "Jing-ui",
            "desc": "<div class=\"markdown\"><p>公司前端团队自研移动端组件库</p></div>",
            "actions": [
              {
                "text": "开始",
                "link": "/components"
              }
            ]
          },
          "features": [
            {
              "icon": "https://gw.alipayobjects.com/zos/bmw-prod/881dc458-f20b-407b-947a-95104b5ec82b/k79dm8ih_w144_h144.png",
              "title": "移动端组件库研发",
              "desc": "<div class=\"markdown\"><p>提炼自企业级移动端产品的交互语言和视觉风格，逐步培养用户的视觉心里和行为习惯</p></div>"
            },
            {
              "icon": "https://gw.alipayobjects.com/zos/bmw-prod/d60657df-0822-4631-9d7c-e7a869c2f21c/k79dmz3q_w126_h126.png",
              "title": "UI规范自成体系",
              "desc": "<div class=\"markdown\"><p>形成规范和标准，降低设计、开发的人力成本和沟通成本</p></div>"
            },
            {
              "icon": "https://gw.alipayobjects.com/zos/bmw-prod/d1ee0c6f-5aed-4a45-a507-339a4bfe076c/k7bjsocq_w144_h144.png",
              "title": "高质量的前端代码实现",
              "desc": "<div class=\"markdown\"><p>使用 TypeScript 开发，支持静态检查，提升开发体验</p></div>"
            }
          ],
          "footer": "<div class=\"markdown\"><p>Open-source MIT Licensed | Copyright © 2021<br />Powered by <a href=\"https://github.com/johanazhu/jingui\" target=\"_blank\">jing-ui<svg xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"\" x=\"0px\" y=\"0px\" viewBox=\"0 0 100 100\" width=\"15\" height=\"15\" class=\"__dumi-default-external-link-icon\"><path fill=\"currentColor\" d=\"M18.8,85.1h56l0,0c2.2,0,4-1.8,4-4v-32h-8v28h-48v-48h28v-8h-32l0,0c-2.2,0-4,1.8-4,4v56C14.8,83.3,16.6,85.1,18.8,85.1z\"></path><polygon fill=\"currentColor\" points=\"45.7,48.7 51.3,54.3 77.2,28.5 77.2,37.2 85.2,37.2 85.2,14.9 62.8,14.9 62.8,22.9 71.5,22.9\"></polygon></svg></a></p></div>",
          "slugs": [
            {
              "depth": 2,
              "value": "浏览器支持",
              "heading": "浏览器支持"
            },
            {
              "depth": 2,
              "value": "反馈与共建",
              "heading": "反馈与共建"
            }
          ]
        },
        "title": "Jing-ui - 一套移动端组件库 - Jing-ui"
      },
      {
        "path": "/guide",
        "component": require('/home/johan/jingqb/jingui/docs/guide/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "docs/guide/index.md",
          "updatedTime": 1658107099000,
          "title": "介绍",
          "order": 1,
          "toc": "menu",
          "nav": {
            "title": "指南",
            "order": 1,
            "path": "/guide"
          },
          "slugs": [
            {
              "depth": 2,
              "value": "特性",
              "heading": "特性"
            },
            {
              "depth": 2,
              "value": "快速上手",
              "heading": "快速上手"
            }
          ]
        },
        "title": "介绍 - Jing-ui"
      },
      {
        "path": "/components/work",
        "meta": {
          "order": 7
        },
        "exact": true,
        "redirect": "/components/work/area"
      },
      {
        "path": "/components/feedback",
        "meta": {
          "order": 5
        },
        "exact": true,
        "redirect": "/components/feedback/better-scroll"
      },
      {
        "path": "/components/base",
        "meta": {
          "order": 2
        },
        "exact": true,
        "redirect": "/components/base/button"
      },
      {
        "path": "/components/config",
        "meta": {
          "order": 9
        },
        "exact": true,
        "redirect": "/components/config/config-provider"
      },
      {
        "path": "/components/navigation",
        "meta": {
          "order": 6
        },
        "exact": true,
        "redirect": "/components/navigation/index-bar"
      },
      {
        "path": "/components/data",
        "meta": {
          "order": 4
        },
        "exact": true,
        "redirect": "/components/data/input"
      }
    ],
    "title": "Jing-ui",
    "component": (props) => props.children
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
